import {useEffect, useRef} from "react";
import Hls from "hls.js";
import ReactPlayer from "react-player";

export const useHlsDebug = (playerRef: React.RefObject<ReactPlayer>) => {
    const hlsRef = useRef<Hls | null>(null);

    useEffect(() => {
        const player = playerRef.current?.getInternalPlayer("hls");

        // rzutujemy tylko jeśli faktycznie jest instancją Hls
        if (player instanceof Hls) {
            hlsRef.current = player;

            // wystawiamy instancję globalnie do debugu
            window.hls = hlsRef.current;

            const hls = hlsRef.current;

            // Eventy debug
            hls.on(Hls.Events.MANIFEST_PARSED, (_, data) => {
                console.log("[HLS] Manifest loaded", data);
            });

            hls.on(Hls.Events.LEVEL_LOADED, (_, data) => {
                console.log("[HLS] Level loaded", data);
            });

            hls.on(Hls.Events.FRAG_LOADED, (_, data) => {
                console.log("[HLS] Fragment loaded", data);
            });

            hls.on(Hls.Events.FRAG_CHANGED, (_, data) => {
                console.log("[HLS] Fragment changed", data);
            });

            hls.on(Hls.Events.LEVEL_SWITCHED, (_, data) => {
                console.log("[HLS] Level switched", data);
            });

            hls.on(Hls.Events.ERROR, (_, data) => {
                console.error("[HLS] Error", data);
            });
        }

        // cleanup przy unmount
        return () => {
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
            window.hls = null;
        };
    }, [playerRef]);

    return hlsRef;
};